module.exports = __webpack_public_path__ + "img/PeakyShop.30a2dcb5.png";